import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Page404 from './views/Page404.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/admin/groups',
      name: 'adminGroups',
      component: () => import( './views/AdminGroups.vue')
    },
    {
      path: '/admin/users',
      name: 'adminUsers',
      component: () => import( './views/AdminUsers.vue')
    },
    {
      path: '/admin/users/card/:id', 
      component: () => import( './views/AdminUsersCard.vue')
    },
    {
      path: '/admin/contacts_functions',
      name: 'contactsFunctions',
      component: () => import( './views/ContactsFunctions.vue')
    },
    {
      path: '/admin/contractors_functions',
      name: 'contractorsFunctions',
      component: () => import( './views/ContractorsFunctions.vue')
    },
    {
      path: '/partners/contractors',
      name: 'contractors',
      component: () => import( './views/Contractors.vue')
    },
    {
      path: '/partners/contractors/card/:id', 
      component: () => import( './views/ContractorsCard.vue')
    },
    {
      path: '/partners/contractors_addresses',
      name: 'contractors_addresses',
      component: () => import( './views/ContractorsAddresses.vue')
    },
    {
      path: '/partners/contractors_addresses/card/:id', 
      component: () => import( './views/ContractorsAddressesCard.vue')
    },
    {
      path: '/partners/contacts',
      name: 'contacts',
      component: () => import( './views/Contacts.vue')
    },
    {
      path: '/partners/contacts/card/:id', 
      component: () => import( './views/ContactsCard.vue')
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    },
    {
      path: '/help',
      name: 'help',
      component: () => import( './views/Help.vue')
    },
    {
      path: '/card/:id', 
      component: () => import( './views/RepairCard.vue')
    },
    {
      path: '*',
      name: '404',
      component: () => import('./views/Page404.vue')
    }
  ]
})
